import { render, staticRenderFns } from "./trafficflowGb.vue?vue&type=template&id=c179a5b4&scoped=true"
import script from "./trafficflowGb.vue?vue&type=script&lang=js"
export * from "./trafficflowGb.vue?vue&type=script&lang=js"
import style0 from "./trafficflowGb.vue?vue&type=style&index=0&id=c179a5b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c179a5b4",
  null
  
)

export default component.exports